import React from "react";
import FilterList from "../../../components/user/expeditionProcess/expeditionProcessFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const StockListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

StockListPage.propTypes = {};

export default StockListPage;
